import React from "react";
import { BASE_URL } from "../../utils/serverContextPath";
import AttachmentList from "./AttachmentList";
import { useTranslation } from "react-i18next";

export default function MessageBubble({

    message,
    currentUser,
    onDownloadFile

}) {



    const { t } = useTranslation();
    const sender = message.sender || {};

    const defaultAvatar =
        "https://cdn-icons-png.flaticon.com/512/847/847969.png";

    const photo = sender.photoUrl
        ? `${BASE_URL}userapp/downloadprofile/${sender.id}`
        : defaultAvatar;

    //--------------------------------------------------------
    // Message envoyé par l'utilisateur connecté ?
    //--------------------------------------------------------

    const isMine =
        currentUser &&
        sender.id === currentUser.id;
    //--------------------------------------------------------
    // Formatage de la date
    //--------------------------------------------------------
    //--------------------------------------------------------
const formatDate = (dateString) => {

    if (!dateString) {
        return "-";
    }

    try {

        // 14/07/2026 23:00:00
        const [datePart, timePart] = dateString.split(" ");

        const [day, month, year] = datePart.split("/");

        const [hour, minute, second] = timePart.split(":");

        const date = new Date(
            year,
            month - 1,
            day,
            hour,
            minute,
            second
        );

        return date.toLocaleDateString(
            "fr-FR",
            {
                day: "2-digit",
                month: "long",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            }
        );
    } catch (error) {
        return dateString;
    }

};

    //--------------------------------------------------------

    return (

        <div
            className={`d-flex mb-4 ${

                isMine
                    ? "justify-content-end"
                    : "justify-content-start"

            }`}
        >

            {
                !isMine &&

                <img

                    src={photo}
                    alt={sender.fullName}
                    className="rounded-circle shadow me-3"

                    style={{

                        width: 55,
                        height: 55,
                        objectFit: "cover"

                    }}

                    onError={(e) => {

                        e.target.src = defaultAvatar;

                    }}

                />
            }

            <div

                className={`card shadow-sm ${

                    isMine
                        ? "border-success bg-success text-white"
                        : "bg-white"

                }`}

                style={{

                    maxWidth: "75%",
                    borderRadius: "18px"

                }}

            >

                <div className="card-body">

                    {/*======================================*/}
                    {/* Nom                                  */}
                    {/*======================================*/}

                    <div>

                        <strong
                            style={{
                                fontSize: "1rem"
                            }}
                        >
                            {sender.fullName}
                        </strong>

                    </div>


                    {/*======================================*/}
                    {/* Date                                 */}
                    {/*======================================*/}

                    <div className="mb-3">

                        <small

                            className={

                                isMine
                                    ? "text-white-50"
                                    : "text-muted"

                            }

                        >

                            <i className="bi bi-clock me-1"></i>

                            {formatDate(message.dateMessage)}

                            

                        </small>

                    </div>


                    {/*======================================*/}
                    {/* Objet                                 */}
                    {/*======================================*/}

                    {

                        message.messageObject &&

                        <h6

                            className={`fw-bold ${

                                isMine
                                    ? "text-white"
                                    : "text-success"

                            }`}

                        >

                            {message.messageObject}

                        </h6>

                    }


                    {/*======================================*/}
                    {/* Corps du message                     */}
                    {/*======================================*/}

                    <div

                        style={{

                            whiteSpace: "pre-wrap",
                            lineHeight: "1.7"

                        }}

                    >

                        {

                            message.messageBody ||
                             t("messageComposer.noContentMessage")

                        }

                    </div>


                    {/*======================================*/}
                    {/* Pièces jointes                       */}
                    {/*======================================*/}

                    <AttachmentList

                        message={message}
                        onDownloadFile={onDownloadFile}
                        isMine={isMine}

                    />

                </div>

            </div>


            {
                isMine &&

                <img

                    src={photo}
                    alt={sender.fullName}
                    className="rounded-circle shadow ms-3"

                    style={{

                        width: 55,
                        height: 55,
                        objectFit: "cover"

                    }}

                    onError={(e) => {

                        e.target.src = defaultAvatar;

                    }}

                />
            }

        </div>

    );

}